"use strict";
import * as e from './echart_utils.js';

// Default values
let config = {
  relay: 'polkadot',
  y: 'normal',
  title2: '(Average)',
  metric: 'avg',
  currentTheme: localStorage.getItem('theme') || 'light'
};

document.addEventListener('DOMContentLoaded', () => {
  initializeConfig(config);
  initializeListeners(config);
  initializeCharts(config);
});

function initializeConfig(config) {
  config.chartsConfig = updateChartsConfig(config);
}

function initializeListeners(config) {
  const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
  toggleSwitch.addEventListener('change', (e) => {
    config.currentTheme = e.target.checked ? 'dark' : 'light';
    localStorage.setItem('theme', config.currentTheme);
    document.body.classList.toggle('dark-mode', config.currentTheme === 'dark');
    updateChartsConfig(config);
  });

  ['ySelection', 'relaySelection', 'metricSelection'].forEach(selection => {
    document.querySelectorAll(`input[name="${selection}"]`).forEach(radio => {
      radio.onchange = function () {
        config[selection.split('Selection')[0]] = this.value;
        updateChartsConfig(config);
      };
    });
  });

  if (localStorage.getItem('theme') === 'dark') {
    toggleSwitch.checked = true;
    document.body.classList.add('dark-mode');
  }
}

function initializeCharts(config) {
  updateChartsConfig(config);
}

function updateChartsConfig(config) {
  if (config.y === 'average') {
    config.title2 = "(Average)";
  } else {
    config.title2 = "(Max)";
  }

  config.chartsConfig = [
    createChartConfig('general_avg_weights', config, config.y.concat('_avg')),
    createChartConfig('general_max_weights', config, config.y.concat('_max'))
  ];

  config.chartsConfig.forEach(cfg => {
    const chart = e.createEchartElement(cfg.elementId, config.currentTheme);
    if (chart) {
      e.loadJSONData(cfg.jsonPath, cfg.relay, data => {
        cfg.build(cfg, data, chart); // Pass chart instance to build function
      }, chart);
    } else {
      console.error(`Failed to create chart for element ${cfg.elementId}`);
    }
  });
}

function createChartConfig(elementId, config, yName) {
  return {
    elementId: elementId,
    jsonPath: `data/block_weights000000000000.jsonl`,
    freq: 'daily',
    relay: config.relay,
    yName: yName,
    build: e.barchart
  };
}